import { CouponTicketButton } from "@/components/marketing/coupon/CouponTicketButton"
import { useBagCoupons } from "@/hooks/use-bag-coupons"
import { bagCouponHeadline } from "@/lib/bag-coupon"
import { TRANSITION } from "@/lib/motion"
import type { Cart } from "@/types"
import { AnimatePresence, motion, useReducedMotion } from "motion/react"

type BagCouponPillProps = {
  cart: Cart
  onOpen: () => void
}

/** A small ink ticket over the bag button while a coupon rides on the order ("CODE · faltam R$ 12,00", "CODE · −R$ 8,90"); tapping it opens the bag on the coupon. */
export function BagCouponPill({ cart, onOpen }: BagCouponPillProps) {
  const { coupons } = useBagCoupons(cart)
  const headline = bagCouponHeadline(coupons)
  const reduceMotion = useReducedMotion()
  const offset = reduceMotion ? 0 : 8

  return (
    <AnimatePresence initial={false}>
      {headline ? (
        <motion.div
          key="bag-coupon-pill"
          initial={{ opacity: 0, y: offset, scale: reduceMotion ? 1 : 0.96 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: offset, transition: TRANSITION.exit }}
          transition={TRANSITION.size}
          className="mb-2 flex justify-center"
        >
          <CouponTicketButton
            title={headline.title}
            mono={headline.title === headline.code}
            status={headline.text}
            tone={headline.tone}
            label={`Cupom ${headline.code}, ${headline.title}: ${headline.text}. Ver na sacola`}
            onClick={onOpen}
          />
        </motion.div>
      ) : null}
    </AnimatePresence>
  )
}
